import { Component, OnDestroy } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnDestroy {
  loader$: Observable<boolean>;
  constructor(private dataService:DataService){
    this.loader$=this.dataService.globalLoader$;
  }
  ngOnDestroy(): void {
  }
}
